function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5 18.2857C29.5 19.4367 28.9832 20.8154 28.0815 22.3081C27.1916 23.7814 25.9897 25.2633 24.7639 26.5963C23.5416 27.9254 22.316 29.0843 21.3943 29.912C21.0464 30.2245 20.7427 30.4889 20.5 30.6966C20.2573 30.4889 19.9536 30.2245 19.6057 29.912C18.684 29.0843 17.4584 27.9254 16.2361 26.5963C15.0103 25.2633 13.8084 23.7814 12.9185 22.3081C12.0168 20.8154 11.5 19.4367 11.5 18.2857C11.5 13.1306 15.5558 9 20.5 9C25.4442 9 29.5 13.1306 29.5 18.2857Z",
  fill: "white",
  stroke: "#00BAFF",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.5007,
  cy: 18.2857,
  rx: 4.16667,
  ry: 4.28573,
  fill: "#00BAFF"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.5007,
  cy: 18.2857,
  rx: 4.16667,
  ry: 4.28573,
  fill: "#00BAFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5 18.2857C29.5 19.4367 28.9832 20.8154 28.0815 22.3081C27.1916 23.7814 25.9897 25.2633 24.7639 26.5963C23.5416 27.9254 22.316 29.0843 21.3943 29.912C21.0464 30.2245 20.7427 30.4889 20.5 30.6966C20.2573 30.4889 19.9536 30.2245 19.6057 29.912C18.684 29.0843 17.4584 27.9254 16.2361 26.5963C15.0103 25.2633 13.8084 23.7814 12.9185 22.3081C12.0168 20.8154 11.5 19.4367 11.5 18.2857C11.5 13.1306 15.5558 9 20.5 9C25.4442 9 29.5 13.1306 29.5 18.2857Z",
  fill: "white",
  stroke: "#00BAFF",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.5007,
  cy: 18.2857,
  rx: 4.16667,
  ry: 4.28573,
  fill: "#00BAFF"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.5007,
  cy: 18.2857,
  rx: 4.16667,
  ry: 4.28573,
  fill: "#00BAFF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5 18.2857C29.5 19.4367 28.9832 20.8154 28.0815 22.3081C27.1916 23.7814 25.9897 25.2633 24.7639 26.5963C23.5416 27.9254 22.316 29.0843 21.3943 29.912C21.0464 30.2245 20.7427 30.4889 20.5 30.6966C20.2573 30.4889 19.9536 30.2245 19.6057 29.912C18.684 29.0843 17.4584 27.9254 16.2361 26.5963C15.0103 25.2633 13.8084 23.7814 12.9185 22.3081C12.0168 20.8154 11.5 19.4367 11.5 18.2857C11.5 13.1306 15.5558 9 20.5 9C25.4442 9 29.5 13.1306 29.5 18.2857Z",
  fill: "white",
  stroke: "#00BAFF",
  strokeWidth: 2
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.5007,
  cy: 18.2857,
  rx: 4.16667,
  ry: 4.28573,
  fill: "#00BAFF"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1,
  width: 38,
  height: 38,
  rx: 19,
  stroke: "url(#paint0_linear_9184_16625)",
  strokeWidth: 2
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_9184_16625",
  x1: -22.5,
  y1: -0.836964,
  x2: -22.5,
  y2: 32.9903,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00BAFF"
})));

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.97dc6467.svg";
export { ForwardRef as ReactComponent };